// extracted by mini-css-extract-plugin
export var pr8Custom = "index-module--pr-8-custom--f4d4a";